export default "__VITE_ASSET__C6caRA5k__"